import { render } from "./consultaCompra.vue?vue&type=template&id=d535a416&scoped=true"
import script from "./consultaCompra.vue?vue&type=script&lang=js"
export * from "./consultaCompra.vue?vue&type=script&lang=js"

import "./consultaCompra.vue?vue&type=style&index=0&id=d535a416&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d535a416"]])

export default __exports__